// @flow
import React from 'react';
import isEmpty from 'lodash/isEmpty';
import get from 'lodash/get';

import PayerSplashWelcomeText from 'components/payer/splash/welcome-text';
import BusinessLogo from 'components/payer/business-logo';
import Button from 'components/shared/button';
import Layout from 'components/shared/layout';

import generateData from 'constants/payer/splash';

import { Copy, Faq, FlexCol, Headline, WidePayerFooter } from './styles';

const FAQ_COPY = 'payments FAQs.';
const FAQ_LINK = 'https://support.hiclark.com/for-students/clark-for-students';

const Splash = ({ business, payer, client, charge, handleClick, logoUrl }: any) => {
  const hasCreditCardPaymentMethod = get(payer, 'relationships.creditCardPaymentMethod.data[0].id');

  const hasPendingCharge = charge && charge.attributes.status === 'pending';
  const noChargeAndMissingPaymentMethod = !charge && !hasCreditCardPaymentMethod;

  return (
    <FlexCol>
      {isEmpty(payer) ? (
        <Layout>
          <Headline>We could not authenticate your account.</Headline>
          <Copy>If this issue persists please contact help@hiclark.com.</Copy>
        </Layout>
      ) : (
        <Layout>
          {logoUrl && <BusinessLogo src={logoUrl} alt="logo" />}
          <Headline>{`Hi ${payer.attributes.firstName}!`}</Headline>
          <PayerSplashWelcomeText paragraphs={generateData(business, client).welcomeParagraphs}>
            <Copy>
              Questions about one-click payments? Check out our{' '}
              <Faq copy={FAQ_COPY} link={FAQ_LINK} />
            </Copy>
          </PayerSplashWelcomeText>
          {(noChargeAndMissingPaymentMethod || hasPendingCharge) && (
            <Button type="button" isSmall onClick={handleClick}>
              Get Started
            </Button>
          )}
        </Layout>
      )}
      <WidePayerFooter />
    </FlexCol>
  );
};

export default Splash;



// WEBPACK FOOTER //
// ./src/components/payer/splash/index.js